import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { AppScopeProvider } from './AppScopeProvider';

/**
 * Public pages (shortlists, callouts, callsheets) render for anonymous
 * visitors, so the organization comes from the URL — the session that normally
 * feeds GlobalAppScopeProvider is absent here.
 */
export function PublicPageAppScope({ children }: { children: ReactNode }) {
  const { app_id } = useParams<{ app_id: string }>();

  return (
    <AppScopeProvider scope={{ level: 'organization', organizationId: app_id }}>
      {children}
    </AppScopeProvider>
  );
}
